















import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			menuList: [
				{
					name: 'aboutUs',
					href: '#about',
				},
				{
					name: 'services',
					href: '#services',
				},
				// {
				// 	name: 'support',
				// 	href: '#support',
				// },
				{
					name: 'contact',
					href: '#contact',
				},
			],
			socialMediaLists: [
				{
					url: 'https://www.facebook.com/gamasys.com.tw/?locale=zh_TW',
					icon: 'icon-facebook',
					iconSize: '20',
				},
				{
					url: 'https://www.instagram.com/gama_technology_fun/?igsh=NjMxYjB6ZG9iZjA2',
					icon: 'icon-instagram',
					iconSize: '20',
				},
				{
					url: 'https://tw.linkedin.com/company/gama-technology-%E5%98%89%E7%A2%BC%E7%A7%91%E6%8A%80',
					icon: 'icon-linkedin',
					iconSize: '20',
				},
				{
					url: 'https://www.104.com.tw/company/dbj2z8w?jobsource=google',
					icon: 'icon-104',
					iconSize: '24',
				},
			],
		};
	},
	methods: {},
});
